import ReactPDF, { Page, Text, View } from "@react-pdf/renderer";
import * as React from "react";
import { IReportingPeriodItem } from "../../../../model/report/ReportingPeriodItem";
import { IReport7ApplicantPresentationModel } from "../../../../presenter/report/model/Report7ApplicantPresentationModel";
import { TTranslate } from "../../../../service/locale/TranslationService";
import Report7PDFTemplateNumericalValuesGrid from "./Report7PDFTemplateNumericalValuesGrid";

const Report7PDFTemplateApplicant = ({
  translate,
  applicant,
  styles,
  selectedReportingPeriod
}: {
  translate: TTranslate;
  applicant: IReport7ApplicantPresentationModel;
  styles: ReactPDF.Styles;
  selectedReportingPeriod?: IReportingPeriodItem;
}) => {
  return (
    <Page size="A4" style={styles.body} orientation={"portrait"}>
      <View style={styles.titleCol}>
        <Text style={styles.title}>{translate("report7_preview.title")}</Text>
        <Text style={styles.subtitle}>{`${translate("report7_preview.name")}: ${
          selectedReportingPeriod?.name || ""
        }`}</Text>
        <Text style={styles.subtitle}>{`${translate(
          "report6_preview_applicant.name_and_surname"
        )}: ${applicant.fullName}`}</Text>
      </View>
      <Report7PDFTemplateNumericalValuesGrid
        translate={translate}
        applicant={applicant}
        styles={styles}
      />
      <Text
        style={styles.pageNumbers}
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        fixed
      />
    </Page>
  );
};

export default Report7PDFTemplateApplicant;
